// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1IW5I","footer":"Form_footer__3SZYn"};